import {
  type CiaLaneListView,
  type GateAccessEligibilityView,
  type VendGateForm,
  type VendGateView,
} from '@m/types/api';
import { apiFetchV2 } from '@m/utils/http';
import { useMutation, useQuery } from '@tanstack/react-query';

/** Matches MaxSearchRadiusMeters / DefaultGeofenceRadiusMeters (250) in
 * https://github.com/metropolis-io/site/blob/master/legacy/site-api/app/io/metropolis/cx/gates/customerinitiatedaccess/CustomerInitiatedAccessServiceImpl.scala
 * Wider GET /customer/gate-access/lanes requests are BAD_REQUEST. */
export const CIA_NEARBY_LANES_DISTANCE_METERS = 250;

export const getGateAccessQueryKey = (uuid: string) => ['customer-gate-access', uuid] as const;

const getGateAccess = async (uuid: string): Promise<GateAccessEligibilityView> =>
  apiFetchV2<GateAccessEligibilityView>(`/customer/gate-access/${uuid}`);

const vendGate = async ({
  uuid,
  body,
}: {
  body: VendGateForm;
  uuid: string;
}): Promise<VendGateView> =>
  apiFetchV2<VendGateView>(`/customer/gate-access/${uuid}/vend`, {
    method: 'POST',
    body,
  });

export const fetchNearbyCiaLanes = async ({
  latitude,
  longitude,
  distanceMeters = CIA_NEARBY_LANES_DISTANCE_METERS,
}: {
  distanceMeters?: number;
  latitude: number;
  longitude: number;
}): Promise<CiaLaneListView> =>
  apiFetchV2<CiaLaneListView>('/customer/gate-access/lanes', {
    params: { latitude, longitude, distanceMeters },
  });

export const useGateAccess = (uuid: string | undefined, enabled = true) =>
  useQuery({
    queryKey: getGateAccessQueryKey(uuid ?? ''),
    queryFn: () => getGateAccess(uuid!),
    enabled: enabled && !!uuid,
    retry: false,
  });

export const useGateVend = () =>
  useMutation({
    mutationFn: vendGate,
  });
